/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HeadingSection, TabItem, Tabs, VFlow } from 'bold-ui'
import { Fragment, useState } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { OdontogramaField, OdontogramaFieldModel } from './components/odontograma-field/OdontogramaField'
import EvolucoesOdonto from './historico-evolucoes-odontologicas/EvolucoesOdonto'
import { HistoricoTecidosMolesTableModel } from './tecidos-moles/historico-tecidos-moles/HistoricoTecidosMolesTable'
import HistoricoTecidosMolesView from './tecidos-moles/historico-tecidos-moles/HistoricoTecidosMolesView'
import TecidosMolesField, { TecidosMolesFieldModel } from './tecidos-moles/TecidosMolesField'

export interface OdontologiaModel {
  odontograma?: OdontogramaFieldModel
  tecidosMoles?: TecidosMolesFieldModel[]
}

export interface EvolucoesOdontologicasViewProps {
  name: MetaPath<OdontologiaModel>
  prontuarioId: ID
  cidadaoDataNascimento: LocalDate
}

enum ActiveTab {
  ODONTOGRAMA,
  TECIDOS_MOLES,
}

// popula a tabela de historico com dados atuais enquanto nao tem integração com o backend
const convertTecidosMolesFieldToTempTableData = (tecidos: TecidosMolesFieldModel[]) =>
  ({
    content:
      tecidos &&
      tecidos.map((tecido) => ({
        ...tecido,
        data: new Date(),
        profissional: 'Profissional',
      })),
    pageInfo: {},
  } as HistoricoTecidosMolesTableModel)

export default function EvolucoesOdontologicasView(props: EvolucoesOdontologicasViewProps) {
  const { name, prontuarioId, cidadaoDataNascimento } = props
  const [activeTab, setActiveTab] = useState<ActiveTab>(ActiveTab.ODONTOGRAMA)

  const {
    input: { value: tempTableData },
  } = useField(name.tecidosMoles.absolutePath(), { subscription: { value: true } })

  return (
    <VFlow>
      <HeadingSection level={3} title='Evoluções odontológicas'>
        <Fragment>
          <Tabs>
            <TabItem active={activeTab === ActiveTab.ODONTOGRAMA} onClick={() => setActiveTab(ActiveTab.ODONTOGRAMA)}>
              Odontograma
            </TabItem>
            <TabItem
              active={activeTab === ActiveTab.TECIDOS_MOLES}
              onClick={() => setActiveTab(ActiveTab.TECIDOS_MOLES)}
            >
              Tecidos moles
            </TabItem>
          </Tabs>

          <div
            css={css`
              padding: 1rem 0;
            `}
          >
            {activeTab === ActiveTab.ODONTOGRAMA && (
              <VFlow>
                <OdontogramaField
                  name={name.odontograma}
                  prontuarioId={prontuarioId}
                  cidadaoDataNascimento={cidadaoDataNascimento}
                />

                <EvolucoesOdonto prontuarioId={prontuarioId} />
              </VFlow>
            )}

            {activeTab === ActiveTab.TECIDOS_MOLES && (
              <VFlow>
                <TecidosMolesField name={name.tecidosMoles} cidadaoDataNascimento={cidadaoDataNascimento} />

                <HistoricoTecidosMolesView
                  prontuarioId={prontuarioId}
                  tempTableData={convertTecidosMolesFieldToTempTableData(tempTableData)}
                />
              </VFlow>
            )}
          </div>
        </Fragment>
      </HeadingSection>
    </VFlow>
  )
}
